import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import HttpUtils from '~/agent/http-utils';

export type ContentProviderSearchResult = {
  asset_id: string;
  title: string;
  description: string;
  link: string;
  image: string;
  duration_seconds: number;
};

interface Response {
  results: ContentProviderSearchResult[];
}

const getContentProviderContentSearchResults = async (provider: string, query: string) =>
  FetchPromise.get(
    HttpUtils.buildUriWithQueryString(`content_provider_integration_connections/search`, {
      provider,
      query,
    }),
  );

export const useGetContentProviderContentSearchResultsQuery = (
  provider: string,
  query: string,
  queryOptions: UseQueryOptions<Response, JQuery.jqXHR> = {},
) =>
  useQuery<Response, JQuery.jqXHR>(
    [provider, query],
    () => getContentProviderContentSearchResults(provider, query),
    queryOptions,
  );
